import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spinner, Alert, AlertIcon, useMediaQuery } from "@chakra-ui/react";
import BGLogin from "./assets/images/image_login.png";
import LogoImg from "./assets/images/Logo-PNG.png";
import UserIconImg from "./assets/images/lucide_user-round.png";
import LogoFooterImg from "./assets/images/logo_footer.png";
import MailIcon from "./assets/mail.svg";

function ForgotPasswordSuccessView() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      {/* Logo */}
      <div style={{ textAlign: "center", marginBottom: 45 }}>
        <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
      </div>

      {/* Main message */}
      <p style={{ color: "#666", fontSize: 15, marginBottom: 12, textAlign: "center", maxWidth: 400, lineHeight: "22px" }}>
        Se ha enviado un correo electrónico de restablecimiento de contraseña a la dirección de correo electrónico de tu cuenta.
      </p>

      {/* Sub-message */}
      <p style={{ color: "#666", fontSize: 14, marginBottom: 45, textAlign: "center", maxWidth: 400 }}>
        Por favor, espera unos minutos antes de intentar otro restablecimiento.
      </p>

      {/* Email icon */}
      <div style={{ marginBottom: 45 }}>
        <img src={MailIcon} alt="" style={{ width: 120, height: 120 }} />
      </div>

      {/* Login link */}
      <p style={{ color: "#666", fontSize: 14 }}>
        ¿Ya tenes cuenta?{" "}
        <Link to="/" style={{ color: "#06ACCD", fontWeight: "bold" }}>Ingresá</Link>
      </p>
    </div>
  );
}

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [registerStatusAlert, setRegisterStatusAlert] = useState(null);
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showImagePanel] = useMediaQuery("(min-width: 769px)");

  async function submit() {
    setLoading(true);
    setRegisterStatusAlert(null);
    var response = await fetch("user/forgotPassword?email=" + email, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    var jsonRes = await response.json();
    switch (jsonRes.error) {
      case false:
        setForgotPasswordSuccess(true);
        break;
      case true:
        setRegisterStatusAlert(
          <Alert status="warning" borderRadius="5px">
            <AlertIcon />
            {jsonRes.message}
          </Alert>
        );
        break;
      default:
        break;
    }
    setLoading(false);
  }

  const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: 15, color: "#333", background: "transparent", textAlign: "center" };
  const inputWrapperStyle = { display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "12px 16px", background: "#fff" };
  const iconStyle = { width: 20, height: 20, marginRight: 12, flexShrink: 0 };
  const inputContainerStyle = { width: "100%", marginBottom: 16, position: "relative" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <style>{`.login-input { text-align: center; }.login-input::placeholder { text-align: center; }`}</style>
      {/* Left side - Form */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "40px 60px", background: "#fff" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 500, margin: "0 auto", width: "100%", paddingTop: 100 }}>
          {forgotPasswordSuccess ? (
            <ForgotPasswordSuccessView />
          ) : (
            <>
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 45 }}>
            <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
          </div>

          {/* Title */}
          <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "24px", letterSpacing: "0%", textAlign: "center", color: "#4A6F96", marginBottom: 20 }}>Olvidé mi contraseña</h1>
          <p style={{ color: "#666", fontSize: 14, marginBottom: 45, textAlign: "center" }}>
            Ingrese su email para iniciar el proceso de reseteo de contraseña
          </p>

          {/* Email input */}
          <div style={{ ...inputContainerStyle, marginBottom: 20 }}>
            <div style={inputWrapperStyle}>
              <img src={UserIconImg} alt="" style={iconStyle} />
              <input
                className="login-input"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
              />
            </div>
          </div>

          {/* Alert */}
          {registerStatusAlert && <div style={{ width: "100%", marginBottom: 16 }}>{registerStatusAlert}</div>}

          {/* Submit button */}
          <button
            type="button"
            onClick={submit}
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              background: "#004890",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              marginBottom: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {loading ? <Spinner size="sm" color="white" /> : "Enviar"}
          </button>

          {/* Login link */}
          <p style={{ color: "#666", fontSize: 14 }}>
            Ya tenes cuenta?{" "}
            <Link to="/" style={{ color: "#06ACCD", fontWeight: "bold" }}>Ingresá</Link>
          </p>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "#999", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <img src={LogoFooterImg} alt="Hospital Británico" style={{ height: 14, width: 35 }} />
          <span>Hospital Británico | © 2025</span>
        </div>
      </div>

      {/* Right side - Image */}
      {showImagePanel && (
        <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <img
            src={BGLogin}
            alt="Portal de prestadores"
            style={{ width: "100%", height: "100%", position: "fixed" }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 150,
              left: 0,
              right: 0,
              background: "linear-gradient(180deg, #020A14,#395D84 )",
              padding: "40px 50px",
              color: "#fff",
              textAlign: "center",
              opacity: 0.6,
            }}
          >
            <h2 style={{ fontWeight: 600, fontSize: "39.84px", lineHeight: "48px", letterSpacing: 0, textAlign: "center", color: "#FFFFFF", marginBottom: 10 }}>
              Bienvenido al portal de <br /> prestadores
            </h2>
            <p style={{ fontWeight: 600, fontSize: "19.84px", lineHeight: "24px", letterSpacing: "0%", textAlign: "center", verticalAlign: "middle", opacity: 0.9 }}>
              Donde podrás Realiza tus tramites y gestiones online
              <br />
              de manera sencilla.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
